import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CognitoService } from '../services/cognito.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private _cognitoService: CognitoService,
    private _router: Router,) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isUserAuthenticated()) {
      return next.handle(req); 
    }

    const token = this.getToken();

    if (token) {
      req = this.addToken(req, token);
    }

    return next.handle(req).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          this.logoutUser();
        }
        return throwError(() => error);
      })
    );
  }

  private isUserAuthenticated(): boolean {
    const token = this.getToken();
    return !!token;
  }

  private addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    return req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }

  private getToken(): string | null {
    return localStorage.getItem('rbac-token');
  }

  private logoutUser(): void {
    console.warn('👋 Cerrando sesión por inactividad dentro del interceptor...');
    this._cognitoService.signOut();
  }
}
